import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center mt-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mx-2 text-2xl font-semibold text-white" }, "サロメディ")
  ])
], -1)
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "ホーム", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "代理店", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "サロン", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "広告枠(アプリ)", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "アフェリエイト", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "トレンド", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "お知らせ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "コンテスト", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "体験・サンプリング", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "サロンジャック", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  class: "flex items-center px-6 py-2 mt-4 duration-200 border-l-4 border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100",
  href: "https://xn-dck9a0c9epc.myshopify.com/admin/reports/sales_over_time?since=2022-03-21&until=2022-03-21&over=hour",
  target: "shopify_sales"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "売上管理")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  class: "flex items-center px-6 py-2 mt-4 duration-200 border-l-4 border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100",
  href: "https://xn-dck9a0c9epc.myshopify.com/admin/orders?inContextTimeframe=last_7_days",
  target: "shopify_orders"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "発送管理")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mx-4" }, "ログアウト", -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.is_sidebar_open ? 'block' : 'hidden', "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebarOpen && _ctx.toggleSidebarOpen(...args)))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.is_sidebar_open ? 'translate-x-0 ease-out' : '-translate-x-full ease-in'
      , "fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"])
    }, [
      _hoisted_2,
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Home' ? _ctx.activeClass : _ctx.inactiveClass]]),
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'DealerList' ? _ctx.activeClass : _ctx.inactiveClass]]),
          to: "/dealers"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'SalonList' ? _ctx.activeClass : _ctx.inactiveClass]]),
          to: "/salons"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [
            _ctx.$route.name === 'AppAdvertisementList'
              ? _ctx.activeClass
              : _ctx.inactiveClass,
          ]]),
          to: "/advertisements/app"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [
            _ctx.$route.name === 'SystemAffeliateList' ? _ctx.activeClass : _ctx.inactiveClass,
          ]]),
          to: "/affeliates/system"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'TrendList' ? _ctx.activeClass : _ctx.inactiveClass]]),
          to: "/trends"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [
            _ctx.$route.name === 'InformationList' ? _ctx.activeClass : _ctx.inactiveClass,
          ]]),
          to: "/information"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'ContestList' ? _ctx.activeClass : _ctx.inactiveClass]]),
          to: "/contests"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'TrialList' ? _ctx.activeClass : _ctx.inactiveClass]]),
          to: "/trials"
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [
            _ctx.$route.name === 'JackRequestList' ? _ctx.activeClass : _ctx.inactiveClass,
          ]]),
          to: "/jackrequests"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["class"]),
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("a", {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [
            _ctx.$route.name === 'SalonJackManagement' ? _ctx.activeClass : _ctx.inactiveClass,
          ]]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signout && _ctx.signout(...args)))
        }, _hoisted_17, 2)
      ])
    ], 2)
  ]))
}